<k2-select
  [matSelectId]="matSelectId"
  [value]="control.value"
  [options]="selectOptions"
  (valueChange)="setValue($event)"
></k2-select>
